import { STANDE, brand, onTint } from "../standeTokens";
import { fileKind } from "../fileTypes";

export { STANDE, brand, onTint };

/**
 * What a lesson is made of, in one glance. Coursera tells you "3 videos,
 * 1 reading" before you open anything; this is the same promise, derived from
 * what is actually attached rather than typed in by the teacher.
 */
export const lessonParts = (segment) => {
  const attachments = segment?.course_segment_attachments || [];
  const videos = attachments.filter((a) => fileKind(a.filename) === "video").length;
  const images = attachments.filter((a) => fileKind(a.filename) === "image").length;
  const files = attachments.filter((a) => fileKind(a.filename) === "file").length;
  const hasReading = Boolean(stripHtml(segment?.overview_html));
  return { videos, images, files, hasReading };
};

export const stripHtml = (html) =>
  (html || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").trim();

/** "2 videos · 1 reading · 3 files" — the empty parts simply do not appear. */
export const partsSummary = (segment) => {
  const { videos, images, files, hasReading } = lessonParts(segment);
  const bits = [];
  if (hasReading) bits.push("Reading");
  if (videos) bits.push(`${videos} video${videos === 1 ? "" : "s"}`);
  if (images) bits.push(`${images} image${images === 1 ? "" : "s"}`);
  if (files) bits.push(`${files} file${files === 1 ? "" : "s"}`);
  return bits.join(" · ");
};

/** Roughly how long the reading takes, at 200 words a minute. Shown only when
 *  there is enough text for the number to mean anything. */
export const readingMinutes = (segment) => {
  const words = stripHtml(segment?.overview_html).split(/\s+/).filter(Boolean).length;
  if (words < 40) return null;
  return Math.max(1, Math.round(words / 200));
};

/** A lesson with neither words nor attachments is a stub the teacher still
 *  has to fill — worth surfacing to them, and worth hiding from students. */
export const isEmpty = (segment) => {
  const { videos, images, files, hasReading } = lessonParts(segment);
  return !hasReading && !videos && !images && !files;
};

export const countLessons = (module) => (module?.child_segments || []).length;

/** Modules with no lessons still hold content of their own, so "empty" for a
 *  module means nothing anywhere beneath it either. */
export const moduleIsEmpty = (module) =>
  isEmpty(module) && (module?.child_segments || []).every(isEmpty);
